import { Box, Typography } from "@mui/material";
import { RelatorioRendaVariavel } from "../../../models/declaracao";
import TabelaBase, {
  CelulaTexto,
  CelulaValor,
  TabelaBaseHeader,
} from "../../util/tabelas/tabelaBase";
import { useUsuario } from "../../../providers/usuarioProvider";

type Props = {
  resultadoMes: RelatorioRendaVariavel;
};

export default function Relatorio5ComumDaytrade({ resultadoMes }: Props) {
  const { claims } = useUsuario();
  return (
    <>
      <Box pb={3}>
        <Typography variant="eyebrow" color="text.secondary" gutterBottom>
          Mercado à Vista
        </Typography>
        <TabelaAVista />
      </Box>
      <Box pb={3}>
        <Typography variant="eyebrow" color="text.secondary" gutterBottom>
          Mercado de Opções
        </Typography>
        <TabelaOpcoes />
      </Box>
      <Box pb={3}>
        <Typography variant="eyebrow" color="text.secondary" gutterBottom>
          Mercado Futuro
        </Typography>
        <TabelaFuturo />
      </Box>
      <Box pb={3}>
        <Typography variant="eyebrow" color="text.secondary" gutterBottom>
          Base de Cálculo do Imposto
        </Typography>
        <TabelaBaseCalculo />
      </Box>
      <Box pb={3}>
        <Typography variant="eyebrow" color="text.secondary" gutterBottom>
          Fundos de Investimento Imobiliário
        </Typography>
        <TabelaFii />
      </Box>
    </>
  );

  function TabelaAVista() {
    const header: TabelaBaseHeader[] = [
      {
        titulo: "",
        key: "c1",
        ordem: 1,
        align: "left",
      },
      {
        titulo: "Operações Comuns",
        key: "c2",
        ordem: 2,
        align: "right",
      },
      {
        titulo: "Operações Daytrade",
        key: "c3",
        ordem: 3,
        align: "right",
      },
    ];

    const rows = [
      {
        c1: <CelulaTexto texto="Mercado à vista - Ações" />,
        c2: (
          <CelulaValor
            valor={resultadoMes?.resultado.comum.aVista}
            copyOnClick
            secret={!!!claims?.stripeRole}
          />
        ),
        c3: (
          <CelulaValor
            valor={resultadoMes?.resultado.daytrade.aVista}
            copyOnClick
            secret={!!!claims?.stripeRole}
          />
        ),
      },
      {
        c1: <CelulaTexto texto="Mercado à vista - Ouro" />,
        c2: <CelulaValor valor={0} copyOnClick />,
        c3: <CelulaValor valor={0} copyOnClick />,
      },
      {
        c1: <CelulaTexto texto="Mercado à vista - Fora de Bolsa" />,
        c2: <CelulaValor valor={0} copyOnClick />,
        c3: <CelulaValor valor={0} copyOnClick />,
      },
    ];
    return <TabelaBase header={header} rows={rows} />;
  }

  function TabelaOpcoes() {
    const header: TabelaBaseHeader[] = [
      {
        titulo: "",
        key: "c1",
        ordem: 1,
        align: "left",
      },
      {
        titulo: "Operações Comuns",
        key: "c2",
        ordem: 2,
        align: "right",
      },
      {
        titulo: "Operações Daytrade",
        key: "c3",
        ordem: 3,
        align: "right",
      },
    ];

    const rows = [
      {
        c1: <CelulaTexto texto="Mercado de Opções - Ações" />,
        c2: (
          <CelulaValor
            valor={resultadoMes?.resultado.comum.opcoes}
            copyOnClick
            secret={!!!claims?.stripeRole}
          />
        ),
        c3: (
          <CelulaValor
            valor={resultadoMes?.resultado.daytrade.opcoes}
            copyOnClick
            secret={!!!claims?.stripeRole}
          />
        ),
      },
      {
        c1: <CelulaTexto texto="Mercado de Opções - Ouro" />,
        c2: <CelulaValor valor={0} copyOnClick />,
        c3: <CelulaValor valor={0} copyOnClick />,
      },
      {
        c1: <CelulaTexto texto="Mercado de Opções - Fora de Bolsa" />,
        c2: <CelulaValor valor={0} copyOnClick />,
        c3: <CelulaValor valor={0} copyOnClick />,
      },
      {
        c1: <CelulaTexto texto="Mercado de Opções - Outros" />,
        c2: <CelulaValor valor={0} copyOnClick />,
        c3: <CelulaValor valor={0} copyOnClick />,
      },
    ];
    return <TabelaBase header={header} rows={rows} />;
  }

  function TabelaFuturo() {
    const header: TabelaBaseHeader[] = [
      {
        titulo: "",
        key: "c1",
        ordem: 1,
        align: "left",
      },
      {
        titulo: "Operações Comuns",
        key: "c2",
        ordem: 2,
        align: "right",
      },
      {
        titulo: "Operações Daytrade",
        key: "c3",
        ordem: 3,
        align: "right",
      },
    ];

    const rows = [
      {
        c1: <CelulaTexto texto="Mercado Futuro - Dólar dos EUA" />,
        c2: (
          <CelulaValor
            valor={resultadoMes?.resultado.comum.dolar}
            copyOnClick
            secret={!!!claims?.stripeRole}
          />
        ),
        c3: (
          <CelulaValor
            valor={resultadoMes?.resultado.daytrade.dolar}
            copyOnClick
            secret={!!!claims?.stripeRole}
          />
        ),
      },
      {
        c1: <CelulaTexto texto="Mercado Futuro - Índices" />,
        c2: (
          <CelulaValor
            valor={resultadoMes?.resultado.comum.indices}
            copyOnClick
            secret={!!!claims?.stripeRole}
          />
        ),
        c3: (
          <CelulaValor
            valor={resultadoMes?.resultado.daytrade.indices}
            copyOnClick
            secret={!!!claims?.stripeRole}
          />
        ),
      },
      {
        c1: <CelulaTexto texto="Mercado Futuro - Juros" />,
        c2: (
          <CelulaValor
            valor={resultadoMes?.resultado.comum.juros}
            copyOnClick
            secret={!!!claims?.stripeRole}
          />
        ),
        c3: (
          <CelulaValor
            valor={resultadoMes?.resultado.daytrade.juros}
            copyOnClick
            secret={!!!claims?.stripeRole}
          />
        ),
      },
      {
        c1: <CelulaTexto texto="Mercado Futuro - Outros" />,
        c2: (
          <CelulaValor
            valor={resultadoMes?.resultado.comum.outros}
            copyOnClick
            secret={!!!claims?.stripeRole}
          />
        ),
        c3: (
          <CelulaValor
            valor={resultadoMes?.resultado.daytrade.outros}
            copyOnClick
            secret={!!!claims?.stripeRole}
          />
        ),
      },
    ];
    return <TabelaBase header={header} rows={rows} />;
  }

  function TabelaBaseCalculo() {
    const header: TabelaBaseHeader[] = [
      {
        titulo: "",
        key: "c1",
        ordem: 1,
        align: "left",
      },
      {
        titulo: "Operações Comuns",
        key: "c2",
        ordem: 2,
        align: "right",
      },
      {
        titulo: "Operações Daytrade",
        key: "c3",
        ordem: 3,
        align: "right",
      },
    ];

    const rows = [
      {
        c1: <CelulaTexto texto="Resultado Negativo até o Mês Anterior" />,
        c2: (
          <CelulaValor
            valor={resultadoMes?.resultado.comum.negativoAnterior}
            copyOnClick
            secret={!!!claims?.stripeRole}
          />
        ),
        c3: (
          <CelulaValor
            valor={resultadoMes?.resultado.daytrade.negativoAnterior}
            copyOnClick
            secret={!!!claims?.stripeRole}
          />
        ),
      },
      {
        c1: <CelulaTexto texto="IR Retido na Fonte no Mês" />,
        c2: (
          <CelulaValor valor={resultadoMes?.resultado.comum.irrf} copyOnClick />
        ),
        c3: (
          <CelulaValor
            valor={resultadoMes?.resultado.daytrade.irrf}
            copyOnClick
            secret={!!!claims?.stripeRole}
          />
        ),
      },
    ];
    return <TabelaBase header={header} rows={rows} />;
  }

  function TabelaFii() {
    const header: TabelaBaseHeader[] = [
      {
        titulo: "",
        key: "c1",
        ordem: 1,
        align: "left",
      },
      { titulo: "Valor", key: "c2", ordem: 2, align: "right" },
    ];

    const rows = [
      {
        c1: <CelulaTexto texto="Resultado Líquido do Mês" />,
        c2: (
          <CelulaValor
            valor={resultadoMes?.resultado.fii.total || 0}
            copyOnClick
            secret={!!!claims?.stripeRole}
          />
        ),
      },
      {
        c1: <CelulaTexto texto="Resultado Negativo do Mês Anterior" />,
        c2: (
          <CelulaValor
            valor={resultadoMes?.resultado.fii.negativoAnterior || 0}
            copyOnClick
            secret={!!!claims?.stripeRole}
          />
        ),
      },
      {
        c1: <CelulaTexto texto="IR Retido na Fonte no Mês" />,
        c2: (
          <CelulaValor
            valor={resultadoMes?.resultado.fii.irrf || 0}
            copyOnClick
            secret={!!!claims?.stripeRole}
          />
        ),
      },
    ];

    return <TabelaBase header={header} rows={rows} />;
  }
}
